import React, { Fragment, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { DialogBox } from '../Dialog';
import { PRNCheckBoxes } from './PRNCheckBoxes';
import { defaults } from './en';
const LinkWrapper = styled.div.withConfig({
  displayName: "Links__LinkWrapper",
  componentId: "iwsj8m-0"
})(["font-style:italic;color:", ";text-decoration:underline;"], props => props.theme.palette.type === 'dark' ? 'white' : 'blue');
export const EntityLink = ({
  name,
  children,
  linkStyle
}) => {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(LinkWrapper, {
    style: linkStyle && linkStyle,
    onClick: () => setOpen(true)
  }, name), /*#__PURE__*/React.createElement(DialogBox, {
    open: open,
    maxWidth: "xl",
    handleClick: () => setOpen(false)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '60vw'
    }
  }, children)));
};

var _ref = /*#__PURE__*/React.createElement("br", null);

export const PSOLink = ({
  pso,
  linkStyle
}) => /*#__PURE__*/React.createElement(EntityLink, {
  name: "PSO",
  linkStyle: linkStyle
}, /*#__PURE__*/React.createElement(PRNCheckBoxes, {
  pso: pso
}), _ref, parse(pso.templatebasedtext));
export const FormLink = ({
  agency,
  keycloak,
  patientNumber,
  dto,
  linkStyle,
  Widget
}) => /*#__PURE__*/React.createElement(EntityLink, {
  name: dto.formname,
  linkStyle: linkStyle
}, /*#__PURE__*/React.createElement("div", {
  style: {
    overflow: 'visible'
  }
}, /*#__PURE__*/React.createElement(Widget, {
  agency: agency,
  keycloak: keycloak,
  patientNumber: patientNumber,
  key: "print",
  viewMode: "print",
  printDTO: [dto],
  printConfig: {
    view: 'Contents'
  },
  displayAllFormTypes: true
})));

var _ref2 = /*#__PURE__*/React.createElement("br", null);

export const Note = /*#__PURE__*/React.memo(({
  ppn,
  pso
}) => ppn && /*#__PURE__*/React.createElement("div", {
  style: {
    whiteSpace: 'pre-wrap'
  }
}, /*#__PURE__*/React.createElement("div", null, ppn.note && parse(ppn.note)), _ref2, pso && /*#__PURE__*/React.createElement(PSOLink, {
  pso: pso
}))); // Need to pass an instance of the Manifest widget; can't import directly due to build
// process order.

export const Manifest = /*#__PURE__*/React.memo(({
  patientNumber,
  mfst,
  agency,
  keycloak,
  Widget,
  observation
}) => {
  const [dto, setDTO] = useState(null);
  useEffect(() => {
    observation && mfst && observation.getFajitaFormByIdByMode(mfst.id, null, agency).then(res => {
      setDTO(res);
    });
  }, []);
  return patientNumber && mfst && dto ? /*#__PURE__*/React.createElement(FormLink, {
    agency: agency,
    keycloak: keycloak,
    dto: dto,
    patientNumber: patientNumber,
    Widget: Widget
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, defaults.loading);
});